import React, {Component} from 'react';
import {Row, Spin, Table} from 'antd';
import {reset, updateSummary} from "../redux_actions/bloodGrid.action";
import {updateWBCSummary, updateWBCTag} from '../redux_actions/wbcview.action'
import {get_response} from "../helper/request";

class BloodSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            table_data: '',
        }

        this.updateCheck = false;

        this.columns = [
            {
                title: <span style={{color: 'cyan',}}>Name</span>,
                dataIndex: 'name',
                render: name => {
                    if (this.props.tag === name || (this.props.tag === '' && name === 'All')) {
                        return <div>
                            <span style={{color: 'green'}}>
                              {name}
                            </span>
                    </div>
                } else {
                    return <div>
                        <a onClick={name === "All" ? () => {
                            this.changeTag('');
                            this.clearFilters();
                        } : () => this.changeTag(name)} style={{color: 'cyan'}}>
                            {name}
                        </a>
                          </div>
                }    
            },
          },
          {
            title:<span style={{color:'cyan', fontSize: '1vw'}}>Count</span>,
            dataIndex: 'count',
            render: count => {
              return <span style={{fontSize: '1vw',}}>{count}</span>
            }
          },
          {
            title:<span style={{color:'cyan', fontSize: '1vw'}}>%</span>,
            dataIndex:'percentage',
            render:( percentage, name )=> {
                if (name.name === "Nucleated RBC" || name.name === "Inconsistent" || name.name === "Other" || name.name === "Smudge Cell")
                    return <span style={{fontSize: '1vw',}}>{"--"}</span>
              return <span style={{fontSize: '1vw',}}>{percentage.toFixed(2)}</span>
            }
          },
        ];

    }

    changeTag = (tag) => {
        this.updateCheck = this.props.wbcGridData.update_summary === true;
        this.props.dispatch(updateWBCTag(tag));
        this.getSummary();
    }

    clearFilters = () => {
        this.updateCheck = this.props.wbcGridData.update_summary === true;
        this.props.dispatch(updateWBCTag(''));
        this.getSummary();
    }

    getSummary = () => {
        if (this.props.update_list === false || this.props.update_list.length === 0 || this.updateCheck === true) {
            let url = `/api/retrieve_summary/?slide_id=${this.props.slide_id}&class=${this.props.class}`;
            get_response(url, true)
                .then(response => {
                    if (response.status === 200) {
                        let resp = response.data['data'];
                        this.setState({
                            table_data: resp,
                        })
                        this.props.dispatch(updateSummary(resp))
                    }
                })
                .catch(err => {
                    console.log("response", err)
                })
        } else {
            this.setState({
                table_data: this.props.update_list,
            })
        }
    }

    componentDidMount = () => {
        this.props.dispatch(reset());
        this.updateCheck = this.props.wbcGridData.update_summary === true;
        this.getSummary();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.wbcGridData.update_summary === true) {
            this.updateCheck = true;
            this.getSummary();
            this.props.dispatch(updateWBCSummary(false));
        }
    }

    render() {
        return (
            <div style={{height: "35vh", marginLeft: '0.4vw'}}>
                <Row>
                    <Table
                        className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header-blood"
                        // style = {{marginTop:'3vh'}}
                        dataSource={this.state.table_data}
                        columns={this.columns}
                        // pagination= {{pageSize:'4', simple:true}}
                        pagination={false}
                      loading={{ indicator:<Spin />, spinning:!this.state.table_data}}
                      // scroll={{ y: 250 }}
                  />
              </Row>
          </div>
      )
    }
}


export default BloodSummary;
